import { useContext, useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogTitle, Button, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material'

import exportFromJSON from 'export-from-json'

import SaveAltIcon from '@mui/icons-material/SaveAlt'
import DataObjectIcon from '@mui/icons-material/DataObject'
import BorderAllIcon from '@mui/icons-material/BorderAll'

import { AppContext } from '/providers/app-context'
import { projectExportData } from '/utils/export-data'

const ArchiveDialog = ({ open, setOpen, fileName, data, excelExport, csvExport, template, table, onExport, exportDisabled = false }) => {

  const { processing, user } = useContext(AppContext)

  const [exportFormat, setExportFormat] = useState(user?.preferences.data_format)

  useEffect(() => {
    setExportFormat(user?.preferences.data_format)
  }, [user])

  const close = () => setOpen(false)

  const exportData = () => {
    const visibleColumns = table?.getVisibleLeafColumns()

    if (onExport) {
      onExport(exportFormat)
      close()
      return
    }
    switch (exportFormat) {
      case "json": return exportJSON(visibleColumns)
      case "csv": return exportCSV(visibleColumns)
      case "xls": return exportXLS(visibleColumns)
    }
  }

  const exportJSON = visibleColumns => {
    const exportType = exportFromJSON.types.json
    const exportData = projectExportData(data, visibleColumns)

    if (Array.isArray(exportData)) {
      exportFromJSON({ data: exportData, fileName, exportType })
    } else {
      for (let key in exportData) {
        const dataItem = exportData[key]
        if (dataItem.length) {
          const fn = fileName + "-" + key
          exportFromJSON({ data: dataItem, fileName: fn, exportType })
        }
      }
    }
    close()
  }

  const exportCSV = visibleColumns => {

    const exportType = exportFromJSON.types.csv
    const exportData = projectExportData(data, visibleColumns)

    if (csvExport) {
      const csvData = csvExport(exportData, visibleColumns)
      exportFromJSON({ data: csvData, fileName, exportType })
    } else {

      if (Array.isArray(exportData)) {
        exportFromJSON({ data: exportData, fileName, exportType })
      } else {
        for (let key in exportData) {
          const dataItem = exportData[key]
          if (dataItem.length) {
            const fn = fileName + "-" + key
            exportFromJSON({ data: dataItem, fileName: fn, exportType })
          }
        }
      }
    }
    
    close()
  }

  const exportXLS = visibleColumns => {
    excelExport({ fileName, data, template, visibleColumns })
    close()
  }

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Data export
      </DialogTitle>

      <div className='p-5'>

        <div className='mb-5'>Use this data as a template to craft your data for creating passes. Use your preference of the three formats for uploading to Studio. Use the JSON format for the API.</div>

        <FormLabel id="export-format-label" className='mt-5'>Export format</FormLabel>
        <RadioGroup
          aria-labelledby="export-format-label"
          row
          value={exportFormat}
          onChange={e => setExportFormat(e.target.value)}
        >
          <FormControlLabel value="json" control={<Radio />} label={<><DataObjectIcon /> JSON</>} />
          <FormControlLabel value="csv" control={<Radio />} label={<><span className='font-semibold'>[*,*]</span> CSV</>} />
          <FormControlLabel value="xls" control={<Radio />} label={<><BorderAllIcon /> Excel (XLSX)</>} />
        </RadioGroup>

      </div>

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={exportData} autoFocus disabled={processing || exportDisabled}><SaveAltIcon className="mr-5" />Export Data</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default ArchiveDialog
